(ns common.modal.dialog
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Typography$default" :as Typography]
            [clojure.spec.alpha :as spec]
            [common.modal.view :refer [modal]]
            [re-frame.core :as rf]))

(spec/def ::hiccup-or-react vector?)

(spec/def ::string-msg-or-hiccup (spec/or :message string? :hiccup ::hiccup-or-react))

(spec/def ::re-frame-event vector?)
(spec/def :form-dialog/on-submit ifn?)

(spec/def :form-dialog/submit-button-disabled? boolean?)
(spec/def ::button-label string?)
(spec/def :form-dialog/submit-button-label ::button-label)
(spec/def :form-dialog/cancel-button-label ::button-label)

(spec/def :form-dialog/props
  (spec/keys :opt-un [:form-dialog/on-submit
                      :form-dialog/submit-button-label
                      :form-dialog/cancel-button-label
                      :form-dialog/submit-button-color
                      :form-dialog/submit-button-disabled?]))

(defn form-dialog
  "Shows a modal dialog with OK (submit) and Cancel button.

   The following properties can be set in the properties map:
   | key                       | description |
   |---------------------------|-------------|
   | `:on-submit`              | Function to be executed when pressing submit button
   | `:submit-button-label`    | Label shown on submit button
   | `:cancel-button-label`    | Label shown on cancel button
   | `:submit-button-color`    | Color of the submit button

  On top of these, all properties for the `common.modal.view/modal` class can be passed here as well."
  [{:keys [on-submit submit-button-label submit-button-disabled? submit-button-testid submit-button-color
           cancel-button-label cancel-button-testid]
    :or {submit-button-label "OK"
         submit-button-disabled? false
         cancel-button-label "Cancel"
         submit-button-color :primary} :as props} & content]
  {:pre [(spec/valid? :form-dialog/props props)]}
  [:form
   {:on-submit (fn [e]
                 (.preventDefault e)
                 (rf/dispatch [:modal/close])
                 (on-submit e))}
   (into [modal
          (merge {:modifier :info
                  :footer [:<>
                           [:> Button {:type "button"
                                       :data-testid cancel-button-testid
                                       :on-click #(rf/dispatch [:modal/close])}
                            cancel-button-label]
                           [:> Button {:color submit-button-color
                                       :variant "contained"
                                       :data-testid submit-button-testid
                                       :disabled submit-button-disabled?
                                       :type "submit"}
                            submit-button-label]]}
                 props)]
         content)])

(defn response-dialog
  "Shows a response modal dialog with the provided title/message and an OK (close) button."
  [{:keys [title message modifier]}]
  [modal
   {:modifier modifier
    :title title
    :footer [:> Button {:variant "contained"
                        :on-click #(rf/dispatch [:modal/close])}
             "OK"]}
   [:> Typography
    {:sx {:minWidth "30rem"}}
    message]])

;;  specialisations of the modal form dialog

;; deletion-confirmation

(spec/def :deletion-confirmation/entity-name string?)
(spec/def :deletion-confirmation/item-label string?)
(spec/def :deletion-confirmation/firm-warning? boolean?)
(spec/def :deletion-confirmation/confirmation-message ::string-msg-or-hiccup)

(spec/def :deletion-confirmation/props
  (spec/merge :form-dialog/props
              (spec/keys :req-un [:deletion-confirmation/entity-name]
                         :opt-un [:deletion-confirmation/confirmation-message
                                  :deletion-confirmation/firm-warning?
                                  :deletion-confirmation/item-label])))

(defn deletion-confirmation
  [{:keys [entity-name confirmation-message firm-warning? item-label]
    :or {confirmation-message (str "Are you sure you want to delete this " entity-name "?")}
    :as props} & content]
  {:pre [(spec/valid? :deletion-confirmation/props props)]}
  (into [form-dialog
         (merge {:modifier :error ; semantically incorrect, but delete dialog must be red
                 :title (str "Delete " entity-name
                             (when item-label (str " '" item-label "'"))
                             "?")
                 :submit-button-label (str "Yes, delete " entity-name)
                 :submit-button-color "error"
                 :submit-button-testid (str "Yes, delete " entity-name)}
                props)
         (when (empty? content)
           [:div
            (when firm-warning?
              [:p "When you delete this " entity-name " there is no way back."])
            [:p confirmation-message]])]
        content))
